<script setup>
import { computed } from 'vue'
import VueApexCharts from 'vue3-apexcharts'

const props = defineProps({
  chartData: {
    type: Object,
    required: true,
  },
  isMobile: {
    type: Boolean,
    default: false,
  },
  isYongsin:{
    type: Boolean,
    default: false,
  }
})

const categoryList = computed(() => {
  return Object.keys(props.chartData || {})
})

const seriesData = computed(() => {
  return categoryList.value.map((category) => Number(props.chartData[category]) || 0)
})

const series = computed(() => [{ data: seriesData.value }])

const radarOptions = computed(() => {
  return {
    chart: {
      parentHeightOffset: 0,
      toolbar: { show: false },
      offsetX: 0,
      offsetY: 15,
    },
    markers: {
      size: 4,
      strokeWidth: 2,
      colors: ['#FF6E6E'],
    },
    fill: { opacity: 0.2 },
    colors: ['#FF6E6E'],
    stroke: {
      width: 3,
      show: true,
    },
    plotOptions: {
      radar: {
        polygons: {
          strokeColors: '#EBEBEB',
          connectorColors: '#EBEBEB',
        },
      },
    },
    grid: {
      padding: {
        top: 20,
        bottom: 20,
        left: 20,
        right: 20,
      },
    },
    yaxis: {
      show: false,
      min: 0,
      max: props.isYongsin ? 40 : 100,
      ...(props.isYongsin ? { tickAmount: 4 } : {}),
    },
    xaxis: {
      categories: categoryList.value,
      labels: {
        offsetX: 0,
        offsetY: 0,
        style: {
          fontSize: '14px',
          fontWeight: 500,
          colors: Array(categoryList.value.length).fill('#757575'),
        },
      },
    },
    tooltip: {
      enabled: true,
      x: {
        show: false,
      },
      y: {
        title: {
          formatter: () => '',
        },
        formatter: (val) => `${val}%`,
      },
      marker: {
        show: false,
      },
      theme: 'dark',
    },
  }
})
</script>

<template>
  <div class="chart-wrapper" :class="{ mobile: isMobile }">
    <VueApexCharts
      type="radar"
      :options="radarOptions"
      :series="series"
      :width="isMobile ? 350 : 400"
      :height="isMobile ? 350 : 400"
    />
  </div>
</template>

<style scoped lang="scss">
.chart-wrapper {
  min-width: 400px;
  min-height: 300px;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: visible;
  &.mobile {
    max-width: 350px;
  }
}
</style>
